// @flow

import React from 'react';
import styled from 'styled-components';
import * as Buttons from 'styles/Buttons';
import * as Layout from 'styles/Layout';

const Wrapper = styled.div`
  margin-bottom: 20px;
`;

const Container = styled(Layout.FlexRow)`
  width: 100%;
`;

const StyledNumberInput = styled.input`
  display: block;
  width: 110px;
  min-width: 110px;
  height: 50px;
  padding: 0 15px;
  border: 1px solid #ececec;
  border-radius: 2px;
  background-color: ${({ disabled }) => (!disabled ? 'white' : '#ececec')};
  line-height: 50px;
  font-size: 30px;
  text-align: center;
  color: #4a4a4a;
  ${props => props.hasError && 'border-color: #dc3545;'}
`;

const ActionButton = styled(Buttons.DefaultButton)`
  height: 50px;
  width: 50px;
  border-radius: 2px;
  color: ${props => (props.color ? props.color : '#278C7E')};
  background-color: #ffffff;
  margin-left: 40px;
  font-weight: bold;
  font-size: 30px;
`;

const ErrorMessage = styled.span.attrs({
  className: 'error-message'
})`
  color: #ff1400;
  top: 35px;
  font-size: 14px;
  line-height: 17px;
  margin-top: 0px;
  position: initial;
`;

type PropsType = {
  name: string,
  value: any,
  onValueChange: (value: string, input: string) => void,
  minNumber: number,
  maxNumber: number,
  intervals: number,
  schema?: any,
  color?: string,
  disabled?: boolean
};

type StateType = {
  error: string,
  inputValue: number
};

export default class NumberInputFormComponent extends React.Component<
  PropsType,
  StateType
> {
  static defaultProps = {
    intervals: 1,
    disabled: false
  };

  constructor(props: PropsType) {
    super(props);
    this.state = {
      error: '',
      inputValue: this.props.value || this.props.minNumber || 0
    };
  }

  incrementAction = (): void => {
    if (this.props.disabled) {
      return;
    }

    const number = parseFloat(this.state.inputValue);
    const incrementNumber = number + this.props.intervals;
    if (incrementNumber <= 1) {
      this.updateStateValidation(1);
    } else if (incrementNumber <= this.props.maxNumber) {
      this.updateStateValidation(incrementNumber);
    }
  };

  decrementAction = (): void => {
    if (this.props.disabled) {
      return;
    }

    const number = parseFloat(this.state.inputValue);
    const decrementNumber = number - this.props.intervals;
    if (decrementNumber >= this.props.minNumber) {
      this.updateStateValidation(decrementNumber);
    }
  };

  onHandleChange = (): void => {
    this.setState({ inputValue: this.state.inputValue });
  };

  onHandleBlur = (): void => {
    this.validationSchema(this.state.inputValue, true, true);
  };

  validationSchema = (
    inputValue: string,
    onBlur: boolean,
    error: boolean
  ): void => {
    const { name } = this.props;
    if (this.props.schema) {
      const value = parseFloat(inputValue);
      this.props.schema
        .validate({ inputValue: value })
        .then(() => {
          this.setState({ error: '' });
        })
        .catch(e => {
          this.setState({ error: e.message });
        });
    }
    if (onBlur && error) this.props.onValueChange(inputValue, name);
  };

  updateStateValidation = (valueNumber: string): void => {
    this.setState({ inputValue: valueNumber }, () =>
      this.validationSchema(this.state.inputValue, true, true)
    );
  };

  render() {
    const { name, disabled } = this.props;
    return (
      <Wrapper>
        <Container>
          <StyledNumberInput
            type="text"
            value={this.state.inputValue}
            name={name}
            onChange={this.onHandleChange}
            onBlur={this.onHandleBlur}
            hasError={this.state.error}
            disabled={disabled}
          />
          <Layout.Spacer />
          <ActionButton
            color={this.props.color}
            onClick={this.decrementAction}
            type="button"
          >
            -
          </ActionButton>
          <ActionButton
            color={this.props.color}
            onClick={this.incrementAction}
            type="button"
          >
            +
          </ActionButton>
        </Container>
        {this.state.error && <ErrorMessage>{this.state.error}</ErrorMessage>}
      </Wrapper>
    );
  }
}
